/**
 * Animation Utils
 */

import { velocityHelpers } from 'velocity-react';

/* tslint:disable-next-line */
import 'velocity-animate/velocity.ui';

const fx = velocityHelpers.registerEffect;

export const ListItemAnimations = (height: number, translateX = -50) => ({
  In: fx({
    defaultDuration: 500,
    calls: [
      [{ height: [height, 0] }, 2 / 5],
      [{
        opacity: [1, 0],
        translateX: [0, translateX],
      }, 3 / 5, { easing: 'easeOutSine' }],
    ],
  }),
  Out: fx({
    defaultDuration: 500,
    calls: [
      [{
        opacity: 0,
        translateX,
      }, 3 / 5, { easing: 'easeInSine' }],
      [{
        height: 0,
      }, 2 / 5],
    ],
    reset: { height },
  }),
});



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/utils/animation.ts